/*
Adds an event listener for events emitted from _inside google ads_ that
will change the HTML meta tag controlling the theme of the device menu (eg: mobile top menu).
Useful for keeping the theme in sync with a banner ad served via google ads.
 */
export const updateThemeTag = (event) => {
  const newColor = event.data?.newColor

  if (CSS.supports('background-color', newColor)) {
    document.querySelector('meta[name="theme-color"]').content = newColor
  }
}

// Paste this function and call itm from any ad native to emit the correct message that'll be updated by the code here
const changeThemeInMainSite = (newColor) => {
  window.top.postMessage({
    eventType: 'carwow-update-theme-color',
    newColor
  })
}
